export default {
    name: 'mvtFactCard',
    props: {
        icon: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            required: true,
        },
        info: {
            type: String,
            required: false,
        },
    },
};
